import { effect, inject, Injectable } from '@angular/core';
import { SERVICE_STORE } from '@features/service/domain/tokens/service-store.token';
import { ServiceRedirectPort } from '@features/service/domain/port/service-redirect.port';

@Injectable({ providedIn: 'root' })
export class ServiceSelectionCompleteSubscriber {
  private readonly store = inject(SERVICE_STORE);
  private readonly redirect = inject(ServiceRedirectPort);

  constructor() {
    effect(() => {
      const { selection } = this.store.state();

      if (
        selection &&
        selection.location &&
        selection.drawer &&
        selection.worker
      ) {
        this.redirect.goToProducts();
      }
    });
  }
}
